var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58199711,4.38594323 C5.31540829,4.11935441 4.98431097,3.78757414 4.98431097,2.49215616 C4.98431097,1.54089536 4.29140768,0.751612731 3.38282506,0.601112858 C3.42710539,0.537157945 3.45078008,0.46119661 3.45067641,0.38340864 C3.45067641,0.171659237 3.27901717,0 3.06726777,0 C2.85551837,0 2.68385913,0.171659237 2.68385913,0.38340864 C2.68385913,0.4642839 2.70896041,0.539264252 2.75171048,0.601112858 C1.84312785,0.751612731 1.15022457,1.54089536 1.15022457,2.49215616 C1.15022457,3.78757414 0.819019411,4.11935441 0.552430591,4.38594323 C0.191199744,4.74717408 0.447208882,5.36772096 0.959095361,5.36772096 L2.30045049,5.36772096 C2.30045049,5.79121977 2.64376896,6.13453824 3.06726777,6.13453824 C3.49076657,6.13453824 3.83408505,5.79121977 3.83408505,5.36772096 L5.17533234,5.36772096 C5.68620039,5.36772096 5.94395883,4.74790495 5.58199711,4.38594323 Z M3.06726777,5.65527744 C3.12020545,5.65527744 3.16311993,5.69819191 3.16311993,5.7511296 C3.16311993,5.80406729 3.12020545,5.84698176 3.06726777,5.84698176 C2.80300336,5.84698176 2.58800697,5.63198537 2.58800697,5.36772096 L2.77971129,5.36772096 C2.77971129,5.5262844 2.90870433,5.65527744 3.06726777,5.65527744 Z",
    id: "path-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9da9f8d87aae892f24fd70a8086f8c90.svg";
export { ForwardRef as ReactComponent };